import ContactChangeModal from "./ContactChangeModal";
import { useConfig } from "../../context/config-context";

// Formats acceptés :
// - 06/07 + 8 chiffres (mobile métropole, préfixe 0, +33 ou 0033)
// - +262/+590/+594/+596 + 9 chiffres (DOM-TOM)
const FRENCH_MOBILE_REGEX = /^(?:\+33|0033|0)([67]\d{8})$/;
const DOM_TOM_REGEX = /^(?:\+262|\+590|\+594|\+596)\d{9}$/;

/**
 * Normalise un numéro mobile au format stocké en base (+336XXXXXXXX), null si invalide
 * (même règle que contactChangeService côté serveur)
 */
const normalizeMobilePhone = (value) => {
  const cleaned = (value || "").replace(/[\s.-]/g, "");
  const metropole = cleaned.match(FRENCH_MOBILE_REGEX);
  if (metropole) return `+33${metropole[1]}`;
  if (DOM_TOM_REGEX.test(cleaned)) return cleaned;
  return null;
};

// Longueur max d'un numéro sans séparateurs : +262 / 0033 + 9 chiffres
const PHONE_MAX_LENGTH = 13;

/**
 * Ne conserve que les chiffres et un "+" en tête (saisie et copier-coller).
 * La longueur est limitée après filtrage pour qu'un numéro collé avec espaces reste complet.
 */
const sanitizePhone = (value) =>
  value
    .replace(/[^\d+]/g, "")
    .replace(/(?!^)\+/g, "")
    .slice(0, PHONE_MAX_LENGTH);

/**
 * UpdateMobilePhoneModal - Modale pour modifier le numéro de téléphone mobile
 * Un code de vérification est envoyé par SMS au nouveau numéro avant toute modification.
 */
export default function UpdateMobilePhoneModal({ currentPhone, onSuccess }) {
  const siteConfig = useConfig();

  const validatePhone = (value) => {
    const phone = normalizeMobilePhone(value);
    if (!phone) {
      return "Numéro de mobile invalide. Format attendu : 06 ou 07 suivi de 8 chiffres (ou +262/+590/+594/+596)";
    }
    if (phone === normalizeMobilePhone(currentPhone)) {
      return "Ce numéro est identique à votre numéro actuel";
    }
    return true;
  };

  return (
    <ContactChangeModal
      type="phone"
      icon={siteConfig.medias.phone_svg}
      title="Modifier le numéro de téléphone mobile"
      currentLabel="Téléphone mobile"
      currentValue={currentPhone}
      newLabel="Nouveau n° de téléphone mobile"
      placeholder="XXXXXXXXXX"
      inputType="tel"
      inputProps={{ inputMode: "tel", autoComplete: "tel" }}
      sanitize={sanitizePhone}
      rules={{
        required: "Le numéro de téléphone est requis",
        validate: validatePhone,
      }}
      isValid={(value) => validatePhone(value) === true}
      onSuccess={onSuccess}
    />
  );
}
